"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var camelCase_1 = __importDefault(require("lodash/camelCase"));
/**
 * Configuration object
 * @typedef {Object} Configuration
 */
/**
 * Get a configuration object from all the data attributes attached to the rootElement.
 * Useful for passing configuration data into a React application from its entry point.
 * Any data attribute will be mapped to a camelCase property on the object. Additionally
 * it will attempt to parse JSON out of any attribute allowing for stringified objects.
 *
 * An element like:
 * ```
 * <div id="root-element" data-config-one="value1" data-stringify-booleans="true"></div>
 * ```
 *
 * Produces a config like:
 * ```
 * {
 *   configOne: "value1",
 *   stringifyBooleans: true
 * }
 * ```
 *
 * @param { HTMLDivElement } rootElement
 * @return { Configuration }
 */
function getConfigFromElementAttributes(rootElement) {
    return rootElement
        .getAttributeNames()
        .filter(function (attr) { return attr.includes('data-'); })
        .reduce(function (acc, current) {
        var cleanName = camelCase_1.default(current.replace('data-', ''));
        var value = rootElement.getAttribute(current);
        try {
            value = JSON.parse(value);
        }
        catch (e) {
            // no-op
        }
        acc[cleanName] = value;
        return acc;
    }, {});
}
exports.default = getConfigFromElementAttributes;
